var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import React, { Component, createRef } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { array } from 'prop-types';
import { ComposableMap, Geographies, Geography, ZoomableGroup } from 'react-simple-maps';
import { Icon } from '@winnin/winnin_ui.components.icon';
import { COLORS } from 'consts';
import { numberUtils } from 'utils';
import './index.scss';
let WorldMap = observer(_class = (_class2 = class WorldMap extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "zoom", _descriptor, this);
    _initializerDefineProperty(this, "center", _descriptor2, this);
    _initializerDefineProperty(this, "showTooltip", _descriptor3, this);
    _initializerDefineProperty(this, "tooltip", _descriptor4, this);
    this.MAX_ZOOM = 12;
    this.MIN_ZOOM = 1;
    this.zoomRef = createRef();
    this.divRef = createRef();
    this.preventDefault = e => e.preventDefault();
    this.zoomIn = () => {
      const next = this.zoom * 1.5;
      if (next <= this.MAX_ZOOM) this.zoom = next;
      // This is used to reset the zoom when the user fully zoom out
      if (next === this.MIN_ZOOM * 1.5) this.center = [0, 1];
    };
    this.zoomOut = () => {
      const next = this.zoom / 1.5;
      if (next >= this.MIN_ZOOM) this.zoom = next;
      // This is used to reset the zoom when the user fully zoom out
      if (next === this.MIN_ZOOM) this.center = [0, 0];
    };
    this.decideZoom = e => {
      if (e.deltaY < 0) this.zoomIn();
      if (e.deltaY > 0) this.zoomOut();
    };
    this.isHighlighted = c => {
      const {
        data
      } = this.props;
      return !!data.find(v => v.country.toLowerCase() === c.toLowerCase());
    };
    this.getColorForCountry = c => {
      if (this.isHighlighted(c)) return COLORS.primary;
      return COLORS.gray;
    };
    this.getHoverColorForCountry = c => {
      if (this.isHighlighted(c)) return COLORS.primary;
      return COLORS.gray;
    };
    this.geographyMove = (evt, geography) => {
      const {
        data
      } = this.props;
      const x = evt.nativeEvent.offsetX;
      const y = evt.nativeEvent.offsetY;
      const country = geography.properties.NAME;
      const object = data.find(v => v.country.toLowerCase() === geography.properties.ISO_A2.toLowerCase());
      if (object) {
        this.showTooltip = true;
        this.tooltip = {
          x,
          y,
          title: country,
          data: {
            percent: numberUtils.formatPercent(object.percent, 1)
          }
        };
      }
    };
    this.geographyLeave = () => {
      this.showTooltip = false;
    };
  }
  handleMoveEnd(position) {
    this.center = position.coordinates;
  }
  componentDidMount() {
    this.divRef.current.addEventListener('wheel', this.preventDefault);
  }
  componentWillUnmount() {
    this.divRef.current.removeEventListener('wheel', this.preventDefault);
  }
  render() {
    return <div className="world-map-container">
        {this.showTooltip && this.tooltip.data && <div className="tooltip-component" style={{
        left: this.tooltip.x,
        top: this.tooltip.y
      }}>
            {this.tooltip.title && <div className="tooltip-title">{this.tooltip.title}</div>}
            <div className="tooltip-series-group">
              <div className="tooltip-text">
                {Object.keys(this.tooltip.data).map(v => <div key={v}>
                    <span className="tooltip-data-title">{`${v}: `}</span>
                    <span className="tooltip-value">{this.tooltip.data[v]}</span>
                  </div>)}
              </div>
            </div>
          </div>}
        <div onWheel={this.decideZoom} className="world-map" ref={this.divRef}>
          <button className="zoom-button zoom-in" onClick={this.zoomIn}>
            <Icon icon="add" className="zoom-icon" />
          </button>
          <button className="zoom-button zoom-out" onClick={this.zoomOut}>
            <Icon icon="remove" className="zoom-icon" />
          </button>
          <ComposableMap projection="geoMercator" projectionConfig={{
          scale: 95,
          rotate: [-10, 0, 0],
          center: [-10, 15]
        }} width={630} height={322}>
            <ZoomableGroup ref={this.zoomRef} zoom={this.zoom} center={this.center} translateExtent={[[0, -322], [630, 322]]} filterZoomEvent={evt => {
            return evt.type === 'wheel' ? false : true;
          }} onMoveEnd={position => this.handleMoveEnd(position)} maxZoom={this.zoom} minZoom={this.zoom}>
              <Geographies geography="https://files.winnin.com/interface/insight/map/world-110m.json">
                {({
                geographies,
                projection
              }) => geographies.map(geography => {
                return geography.properties.ISO_A3 !== 'ATA' && <Geography key={geography.rsmKey} geography={geography} projection={projection} className={`country ${geography.properties.ISO_A3}`} onMouseMove={e => this.geographyMove(e, geography)} onMouseLeave={this.geographyLeave} style={{
                  default: {
                    fill: this.getColorForCountry(geography.properties.ISO_A2),
                    strokeWidth: 0,
                    outline: 'none'
                  },
                  hover: {
                    fill: this.getHoverColorForCountry(geography.properties.ISO_A2),
                    strokeWidth: 0,
                    outline: 'none'
                  },
                  pressed: {
                    fill: this.getHoverColorForCountry(geography.properties.ISO_A2),
                    strokeWidth: 0,
                    outline: 'none'
                  }
                }} />;
              })}
              </Geographies>
            </ZoomableGroup>
          </ComposableMap>
        </div>
      </div>;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "zoom", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "center", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [0, 0];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "showTooltip", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "tooltip", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _class2)) || _class;
WorldMap.propTypes = {
  data: array
};
WorldMap.defaultProps = {};
WorldMap.displayName = 'WorldMap';
export default WorldMap;